import Css from './Mockup.module.css'

export default function Notices() {
    return (
        <div className={Css.noticebottom}>
            <img src={require("images/comingsoon3.jpg")} className={Css.layout_notices} />
        </div>
    )
}